import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'
import Button from 'theme/atoms/Button'

export default function SkipToContentButton() {
  const t = useTranslations<'app-SkipToContentButton'>()

  const [visible, setVisible] = React.useState<boolean>(false)
  return (
    <Wrapper
      data-cy-ctx="app/SkipToContentButton"
      className="SkipToContentButton"
      $visible={visible}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      aria-label={t.asText(false, 'BFSG_skip_to_main_content_action')}
    >
      <a href="#main-content" tabIndex={-1}>
        <Button variation="secondary">{t('skip_to_main_content')}</Button>
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $visible: boolean }>`
  z-index: ${theme.zIndex.app_skip_to_content_button};
  ${(props) =>
    props.$visible ? `transform: scale(1);` : `transform: scale(0);`}
  transition: transform 200ms;
  position: absolute;
  top: ${theme.spacing('xxs')};
  left: ${theme.spacing('xxs')};
`
